module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-235.bb5f3ed2.jpg";